import React from "react";
import { Row } from "react-bootstrap";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import TableSection from "./TableSection";
import { useExisteListaAsistenciaDeHoy } from "../../../services/asistenciaServicios";
import LoadingScreen from "../../organisms/LoadingScreen";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import InformationModal from "../../organisms/InformationModal";
import { useNavigate } from "react-router-dom";
import { RUTA_ASISTENCIA } from "../../../services/rutas";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/asistencia",
    label: "Asistencia",
  },
  {
    path: "/checkin",
    label: "Check in",
    isActive: true,
  },
];

function CheckinAsistencia() {
  const navigate = useNavigate();

  const {
    data: existeListaDeHoy,
    isLoading,
    error,
    isSuccess,
  } = useExisteListaAsistenciaDeHoy();

  const onCloseInformationModal = () => {
    navigate(RUTA_ASISTENCIA);
  };

  return (
    <Page
      title="Check-in diario"
      description="Registro de asistencia mascotas programadas para el día de hoy."
      breadCrumbs={breadCrumbs}
    >
      <Row className="justify-content-center">
        <div className="col-xs-12 col-md-10 col-lg-10 col-xxl-7">
          <>
            {existeListaDeHoy && isSuccess && <TableSection />}
            {!existeListaDeHoy && isSuccess && (
              <InformationModal
                message="No hay asistencias programadas para el día de hoy."
                onClose={onCloseInformationModal}
              />
            )}
            {error && <ServerErrorModal />}
            {isLoading && <LoadingScreen isLoading={isLoading} />}
          </>
        </div>
      </Row>
    </Page>
  );
}

export default CheckinAsistencia;
